import { Box } from '@material-ui/core'
import { Loader } from 'components/core/loader'
import { Dispatch, MutableRefObject, PropsWithChildren, SetStateAction } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { StyledMentionsList } from './styled'
// @ts-ignore
import { useTheme } from 'styled-components'
import { IMentionable } from 'common/types/mentions.types'
import { MentionsResultList } from './MentionsResultList'
import { ITagSearchItem } from 'common/types/hashtags.types'
import { TaggingResultList } from './TaggingResultList'

export interface IMentionsSuggestionsListProps {
  users?: IMentionable[]
  totalSuggestions: number
  mentionedCounter: number
  typingID: string
  mentionedContainerClass: string
  value: string
  isMentioning: boolean
  getResults: Function
  setText: Function
  setMentions: Function
  resetMentioningRef: MutableRefObject<Function>
  setCharacterCount: (newVal: number) => void
  shouldUpdateTextfield?: boolean
  hasTagActive?: boolean
  maxHeight?: string
  tags?: IMentionable[]
  tagResults?: ITagSearchItem[]
  setTags?: Function
  setTagResults?: Dispatch<SetStateAction<ITagSearchItem[]>>
  isTagging?: boolean
  searchText?: string
  hashCount?: number
  setAutoTag?: Function
  autoTag?: boolean
  setSelectedTarget?: Function
}

export const MentionsSuggestionsList = (props: PropsWithChildren<IMentionsSuggestionsListProps>) => {
  const {
    users,
    totalSuggestions,
    getResults,
    isMentioning,
    shouldUpdateTextfield: _shouldUpdateTextfield,
    maxHeight,
    value: html,
    hasTagActive,
    isTagging,
    tagResults,
    searchText
  } = props
  const theme = useTheme()

  const hasSearchText = tagResults?.find(_tag => _tag.topic === searchText)

  let topics: ITagSearchItem[] = tagResults || []

  if (!hasSearchText && !!searchText?.trim()) {
    topics = [{ topic: searchText }, ...(tagResults || [])]
  }

  const newProps = {
    ...props,
    tagResults: topics
  }

  const hasData = !!users?.length || (hasTagActive && !!topics?.length)

  const dataLength = isTagging ? (hasTagActive && topics?.length) || 0 : users?.length

  const id = `suggestions`

  return (
    <>
      {hasData && isMentioning && (
        <Box position="relative" width="100%">
          <StyledMentionsList
            bgcolor={theme.colors.supplementary1}
            position={'absolute'}
            zIndex={1}
            width={isTagging ? '59%' : '100%'}
            maxHeight={maxHeight ?? '191px'}
            overflow={'auto'}
            id={id}
            borderRadius="11px"
            boxShadow={'0px 3px 10px -1px rgba(0, 0, 0, 0.43)'}
          >
            <InfiniteScroll
              loader={<Loader />}
              hasMore={totalSuggestions > dataLength}
              endMessage={
                <p style={{ textAlign: 'center', color: theme.colors.accent1 }}>
                  {dataLength === 0 ? <b>No Suggestions</b> : <b>No More Suggestions</b>}
                </p>
              }
              next={() => {
                getResults(searchText, true, isTagging ? false : true)
              }}
              dataLength={dataLength}
              scrollableTarget={id}
            >
              {isTagging ? <TaggingResultList {...newProps} /> : <MentionsResultList {...newProps} />}
            </InfiniteScroll>
          </StyledMentionsList>
        </Box>
      )}
    </>
  )
}
